import { AdobePageLoadEvent } from './adobe-page-load';
import { NutritionCalculatorPageLoadEvent } from '@/services/analytics/events';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';
import { WebPageDetails } from '../models';

export class AdobeNutritionCalculatorPageLoadEvent extends AdobePageLoadEvent {
  pageLoadName = 'nutrition-calculator';

  constructor(event: NutritionCalculatorPageLoadEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    if(!store.state.adobe.hasNutritionCalcPageBeenViewed) {
      services.analytics.setNutritionCalcPageHasBeenViewed();
    }

    Object.assign(this.web.webPageDetails, {   
      pageType: 'nutrition',
      pageViews: { value: 1 },
      server: 'https://wwww.chipotle.com',
      subSection1: '',
      name: (event.eventType === 'meal-builder' && event.mealType) ? this.pageLoadName + '|' + event.mealType : this.pageLoadName,
      siteSection: (event.eventType === 'meal-builder' && event.mealType) ? event.mealType : 'home',
    } as WebPageDetails)

    if (store.state.adobe.isMakeItMyOwn) {
      this.commerce.pceMakeItMyOwn = { value: 1 };
      services.utils.setIsMakeItMyOwn(false);
    }
  }
}
